import { Component, Inject, OnInit } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-show-pull-data-link',
  templateUrl: './show-pull-data-link.component.html',
  styleUrls: ['./show-pull-data-link.component.scss']
})
export class ShowPullDataLinkComponent implements OnInit {
  url
  constructor(public dialogRef: MdDialogRef<ShowPullDataLinkComponent>,
    @Inject(MD_DIALOG_DATA) public data: any) {
      console.log(data);
      var token=data.split('.');

      this.url="https://13.126.36.205/pullData/pullDataForUser1?token="+token[1]
    }

  ngOnInit() {
  }

  close(){
    this.dialogRef.close()
  }
}



// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/add/show-pull-data-link/show-pull-data-link.component.ts